import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid/main';

@Component({
  selector: 'lfwms-account-num-cell-renderer',
  templateUrl: './account-num-cell-renderer.component.html',
  styleUrls: ['./account-num-cell-renderer.component.css']
})
export class AccountNumberCellRendererComponent implements ICellRendererAngularComp {

  public params: any;
  public cellValue: any;
  public cellDisplayValue: string = '';

  public agInit(params: ICellRendererParams): void {
    this.params = params;
    if (this.params.value) {
      this.cellValue = this.params.value.cVal;
    }

    if (this.params.cellMetaData
      && this.params.cellMetaData.type === 'DROPDOWN') {
      const filteredOptions: Array<any> = this.params.cellMetaData.values
        .filter((option: any) => {
          return option.key === this.cellValue;
        });
      this.cellDisplayValue
        = ((filteredOptions.length > 0) ?
          filteredOptions[0].key : this.cellValue);
      if (this.cellDisplayValue === '- Select -') {
        this.cellDisplayValue = '';
      }
    }
  }

  public refresh(): boolean {
    return true;
  }

}




// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/inventory/pallet-management/pallet-management-inventory/account-num-cell-renderer/account-num-cell-renderer.component.ts